import styled from 'styled-components';
import { BREAKPOINTS } from '@config/grid/constants';
import theme from '@config/theme';
import { IContentContainerProps } from './types';

const Container = styled.div<IContentContainerProps>`
  width: 95vw;
  display: flex;
  flex-direction: column;
  background-color: ${theme.palette.neutral.transparent};
  max-width: ${(props) => (props.fixedWidth ? `${BREAKPOINTS.lg}px` : '100vw')};
  margin: 0 auto;
  
  @media ${theme.device.laptopL} {
    width: 80vw;
    height: unset;
  }
`;
Container.displayName = 'Container';

export default Container;
